// import React, { useState } from "react";
// import Header from "../components/layout/Header";
// import Footer from "./Footer";
// import "./blogs.css";

// import imgSigns     from "../assets/images5.jpeg";
// import imgSafety    from "../assets/images6.jpeg";
// import imgDiabetes  from "../assets/image13.jpg";
// import imgDementia  from "../assets/image16.jpg";
// import imgTalk      from "../assets/image12.jpg";
// import imgTelecare  from "../assets/image15.jpg";

// const BLOG_POSTS = [
//   {
//     id: 1,
//     category: "Family Guidance",
//     title: "5 Early Signs Your Aging Parent May Need Extra Support",
//     excerpt:
//       "Most families don't notice the shift overnight — it happens in small moments. Here's what to watch for before a routine day becomes a crisis.",
//     readTime: "4 min read",
//     image: imgSigns,
//     content: [
//       "It rarely starts with a fall or a hospital visit. Long before that, there are small, easy-to-miss signs — a missed medication, a pile of unopened mail, a fridge with more expired food than fresh. Families often only connect the dots in hindsight.",
//       "Watch for changes in daily routines: skipped meals, unusual weight loss or gain, or clothes that no longer fit because they've stopped being washed regularly. Personal hygiene slipping is another early indicator — not because your parent doesn't care, but because the steps involved have quietly become harder to manage alone.",
//       "Pay attention to the home itself. Unpaid bills, unusual clutter, or bruises your parent brushes off as 'nothing' can point to mobility issues or memory changes they haven't mentioned. Social withdrawal — skipping calls, avoiding get-togethers, or losing interest in hobbies — is also a common early signal, and one families frequently mistake for simply 'getting older.'",
//       "None of these signs alone means it's time for major intervention. But together, they're worth a structured conversation — and often, a proper assessment. A short wellness check-in with a professional can tell you far more than a phone call ever will, and can help you build a care plan around what your parent actually needs, rather than guessing.",
//       "If you're noticing two or more of these signs, it's a good moment to start the conversation — not with alarm, but with curiosity. Ask what's been hard lately. You may be surprised how relieved they are that you asked.",
//     ],
//   },
//   {
//     id: 2,
//     category: "Home Safety",
//     title: "Fall-Proofing the Home: A Room-by-Room Safety Checklist",
//     excerpt:
//       "Falls are the leading cause of injury-related hospital visits among seniors — and most are preventable with a few simple changes at home.",
//     readTime: "5 min read",
//     image: imgSafety,
//     content: [
//       "A fall doesn't just cause physical injury — it often shakes an older adult's confidence badly enough that they start avoiding movement altogether, which ironically makes future falls more likely. Prevention is almost always easier than recovery.",
//       "Bathroom: This is where most home falls happen. Install grab bars near the toilet and inside the shower, use a non-slip mat both inside and just outside the tub, and consider a raised toilet seat if getting up is difficult. A shower chair removes the risk of standing on wet tile for extended periods.",
//       "Bedroom: Keep a clear, well-lit path from the bed to the bathroom — this is when most nighttime falls occur. A lamp within arm's reach of the bed, rather than a switch across the room, makes a real difference. Avoid loose rugs, or secure them firmly with non-slip backing.",
//       "Kitchen and living areas: Rearrange frequently used items to waist or shoulder height so there's no need to climb or bend awkwardly. Tape down or remove loose cords. Make sure furniture is stable enough to lean on, and avoid low, deep chairs that are hard to get out of.",
//       "Stairs and entryways: Handrails on both sides, good lighting at both the top and bottom, and non-slip strips on each step go a long way. Outside, check that pathways are even and well lit, especially near the front door.",
//       "Beyond the physical setup, a professional home safety assessment can catch risks a family member might miss simply because they're used to the space. It's a small step that meaningfully lowers the odds of a fall turning into a hospital stay.",
//     ],
//   },
//   {
//     id: 3,
//     category: "Chronic Care",
//     title: "Managing Diabetes in Seniors: A Practical Guide for Families",
//     excerpt:
//       "Diabetes management looks different at 70 than it does at 40. Here's what families should actually focus on.",
//     readTime: "6 min read",
//     image: imgDiabetes,
//     content: [
//       "Diabetes care for older adults isn't just about tighter blood sugar control — in fact, overly strict targets can sometimes do more harm than good, increasing the risk of dangerous low blood sugar episodes. The real goal is steady, sustainable management that fits daily life.",
//       "Routine monitoring matters more than perfection. Regular blood sugar checks, done at consistent times, help spot patterns — like a dip every afternoon, or a spike after a particular meal — that a single reading would never reveal. Share these patterns with a doctor rather than reacting to any one number in isolation.",
//       "Medication management deserves particular attention. Multiple daily medications, sometimes for diabetes and other conditions together, create real risk for missed or doubled doses. A simple pill organizer, a set daily routine, and periodic check-ins go a long way toward avoiding this.",
//       "Diet doesn't need to mean deprivation. Small, consistent changes — more fibre, smaller portions spread across the day, cutting back on sugary drinks — tend to work far better long-term than a strict overhaul that's hard to sustain. Involve your parent in the plan rather than dictating it; adherence improves dramatically when people feel ownership over their own care.",
//       "Foot care is often overlooked but genuinely important — diabetes can reduce sensation in the feet, so small cuts or blisters can go unnoticed and worsen. A quick daily visual check, comfortable well-fitting shoes, and prompt attention to any wound are simple habits that prevent serious complications.",
//       "Finally, don't underestimate the value of regular lab work and teleconsultations. Diabetes is a condition that quietly shifts over time, and a plan that worked a year ago may need adjusting today. Structured, scheduled check-ins — rather than reactive visits only when something goes wrong — make the biggest long-term difference.",
//     ],
//   },
//   {
//     id: 4,
//     category: "Chronic Care",
//     title: "Understanding Dementia Care at Home: What Families Should Know",
//     excerpt:
//       "A dementia diagnosis changes a lot — but with the right structure, most families can provide excellent care at home for years.",
//     readTime: "6 min read",
//     image: imgDementia,
//     content: [
//       "Dementia care is as much about the caregiver's approach as it is about medical treatment. Confusion, repeated questions, or sudden mood changes aren't something to correct or argue with — they're symptoms, and responding with patience rather than logic tends to work far better for everyone involved.",
//       "Routine is one of the most powerful tools available. Consistent mealtimes, familiar surroundings, and predictable daily patterns reduce the anxiety that often comes with memory loss. Big changes — a new caregiver, a rearranged room, an unfamiliar visitor — can be genuinely disorienting, so introduce them gradually wherever possible.",
//       "Safety needs a second look through a dementia-specific lens. Beyond typical fall-proofing, consider stove safety, door locks to prevent wandering, and removing small objects that could be mistaken for food. Labeling drawers and rooms with simple words or pictures can also help maintain a sense of independence for longer.",
//       "Communication matters more than it might seem. Short, simple sentences, one question at a time, and allowing extra time to respond all reduce frustration on both sides. Correcting factual errors ('No, mom, dad passed away years ago') often causes distress without any real benefit — redirecting the conversation gently is usually kinder and more effective.",
//       "Caregiver burnout is real and common, and it's not a sign of failing — dementia caregiving is genuinely demanding. Regular respite, whether that's a few hours of professional support each week or scheduled home visits, isn't a luxury; it's what makes sustainable long-term care possible at all.",
//       "A structured care plan with regular cognitive check-ins, caregiver guidance, and a clear emergency protocol takes a significant amount of guesswork — and stress — off the family, while giving your parent the stability that matters most.",
//     ],
//   },
//   {
//     id: 5,
//     category: "Family Guidance",
//     title: "How to Talk to Your Parents About Getting Help (Without the Guilt)",
//     excerpt:
//       "It's one of the hardest conversations families have. Here's how to approach it in a way that respects your parent's independence.",
//     readTime: "4 min read",
//     image: imgTalk,
//     content: [
//       "Nobody wants to feel like they're losing control of their own life — and for most parents, that's exactly what a conversation about 'getting help' can feel like if it's not handled carefully. The goal isn't to convince them they can't manage. It's to make sure they don't have to manage everything alone.",
//       "Start with curiosity, not conclusions. Instead of 'I think you need help,' try 'How has the morning routine been feeling lately?' or 'Is there anything that's gotten harder this year?' This opens a conversation instead of triggering a defense.",
//       "Timing matters. Bring it up during a calm, unhurried moment — not right after an incident, when emotions are high and it can feel like an ultimatum. A relaxed conversation over tea tends to go much further than one that starts with 'we need to talk.'",
//       "Frame support as addition, not subtraction. Professional help for a few hours a week, or check-in visits, don't have to mean giving anything up — they can mean having more energy for the things that actually matter, like time with grandchildren, instead of spending it on tasks that have become tiring.",
//       "Expect resistance, and don't take it personally. It's common for the first conversation to go nowhere, and that's okay — plant the seed and revisit it later rather than pushing for a decision in one sitting. Most families find it takes two or three conversations before a parent is genuinely open to the idea.",
//       "If your parent agrees to even a small step — a single home visit, one wellness check — treat it as a win. It's often the first visit that changes their mind entirely, once they see that support doesn't mean losing their independence.",
//     ],
//   },
//   {
//     id: 6,
//     category: "Planning Ahead",
//     title: "The Real Cost of \"We'll Handle It Ourselves\"",
//     excerpt:
//       "Most families don't plan for elder care until they're already in a crisis. Here's why building structure early actually saves more than it costs.",
//     readTime: "5 min read",
//     image: imgTelecare,
//     content: [
//       "\"We'll figure it out when the time comes\" is one of the most common — and most expensive — approaches to elder care. Not expensive in money necessarily, but in the toll it takes on families who end up making major decisions during a hospital hallway conversation instead of ahead of time.",
//       "Reactive care tends to cost more, not less. An emergency hospitalization, a rushed hire of unvetted home help, or a scramble to coordinate doctors, lab work, and medication after a health scare is almost always more expensive and more stressful than a plan built in advance.",
//       "Structured care isn't about assuming the worst — it's about removing decision-making from moments when it's hardest to think clearly. Knowing who to call in an emergency, having a doctor-on-call relationship already in place, and having medical records organized and accessible means a crisis stays a manageable event instead of becoming a chaotic one.",
//       "It also protects the family's time and relationships. When care is unplanned, it tends to fall unevenly on whichever adult child lives closest or has the most flexible schedule — often leading to burnout and quiet resentment. A shared, structured plan distributes that load more fairly, and makes space for everyone to simply spend time with their parents, rather than only managing them.",
//       "The families who feel most at peace with elder care aren't the ones with the fewest challenges — they're the ones who built a plan before they needed it. It doesn't have to mean handing everything over to someone else. Even a lightweight structure — regular check-ins, a documented care plan, a clear point of contact for emergencies — makes an enormous difference when something does happen.",
//       "If you've been putting off 'the conversation' about your parents' care, this is your sign that starting small today is worth more than waiting for the perfect moment. It rarely comes on its own.",
//     ],
//   },
// ];

// const CATEGORY_COLORS = {
//   "Family Guidance": "var(--base-primary, #004F9E)",
//   "Home Safety":      "var(--base-secondary, #F17A00)",
//   "Chronic Care":     "var(--base-primary, #004F9E)",
//   "Planning Ahead":   "var(--base-secondary, #F17A00)",
// };

// function BlogModal({ post, onClose }) {
//   if (!post) return null;
//   return (
//     <div className="blog-modal-overlay" onClick={onClose}>
//       <div className="blog-modal" onClick={(e) => e.stopPropagation()}>
//         <button className="blog-modal-close" onClick={onClose} aria-label="Close">✕</button>
//         <img src={post.image} alt={post.title} className="blog-modal-image" />
//         <div className="blog-modal-body">
//           <span
//             className="blog-tag"
//             style={{ background: CATEGORY_COLORS[post.category] }}
//           >
//             {post.category}
//           </span>
//           <h2>{post.title}</h2>
//           <p className="blog-modal-meta">{post.readTime}</p>
//           {post.content.map((para, i) => (
//             <p key={i} className="blog-modal-para">{para}</p>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// function Blogs() {
//   const [activePost, setActivePost] = useState(null);

//   return (
//     <div>
//       <Header />

//       {/* HERO */}
//       <div className="blogs-hero">
//         <div className="blogs-hero-overlay">
//           <h1>Elder Care, Explained</h1>
//           <p>Practical guidance for families navigating care for aging parents — written by the Suvidha team.</p>
//         </div>
//       </div>

//       {/* GRID */}
//       <div className="blogs-container">
//         {BLOG_POSTS.map((post) => (
//           <div
//             key={post.id}
//             className="blog-card"
//             onClick={() => setActivePost(post)}
//           >
//             <div className="blog-card-image-wrap">
//               <img src={post.image} alt={post.title} className="blog-card-image" />
//               <span
//                 className="blog-tag blog-tag-onimage"
//                 style={{ background: CATEGORY_COLORS[post.category] }}
//               >
//                 {post.category}
//               </span>
//             </div>
//             <div className="blog-card-body">
//               <h3>{post.title}</h3>
//               <p className="blog-card-excerpt">{post.excerpt}</p>
//               <div className="blog-card-footer">
//                 <span className="blog-read-time">{post.readTime}</span>
//                 <span className="blog-read-more">Read more →</span>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <BlogModal post={activePost} onClose={() => setActivePost(null)} />

//       <Footer />
//     </div>
//   );
// }

// export default Blogs;

import React from 'react'
import Header from '../components/layout/Header'

function Blogs() {
  return (
    <div>
      <Header/>
      
    </div>
  )
}

export default Blogs
